import { Link } from 'react-router-dom';
import Logo from '../ui/Logo.jsx';
import { useApi } from '../../hooks/useApi.js';
import { getCategories } from '../../api/catalogApi.js';
import { LINE_ID, LINE_ADD_URL } from '../../constants/contact.js';

// 有獨立頁的分類：連去該頁，其餘導商品一覽對應分類（與商品一覽側邊欄一致）
const STANDALONE_CATEGORY_LINKS = { virtual: '/virtual' };
const categoryLink = (id) => STANDALONE_CATEGORY_LINKS[id] || `/shop?category=${id}`;

const INFO_GROUP = {
  title: '資訊',
  // 暫時全隱藏（功能未做）：比賽資訊/News、標所地圖、飛鏢知識。空群組不會渲染。
  items: [],
};

const SUPPORT_GROUP = {
  title: '客服',
  items: [
    { label: '運送說明', desc: '目前僅 7-11 店到店' },
    { label: 'Email：michidart12345@gmail.com', href: 'mailto:michidart12345@gmail.com' },
    { label: `LINE：${LINE_ID}`, href: LINE_ADD_URL },
  ],
};

function Footer() {
  // 商品分類動態抓，與後台設定 / 首頁 / 商品一覽一致
  const { data: categories = [] } = useApi(() => getCategories(), []);

  const productItems = categories.map(c => ({
    label: c.en ? `${c.name} ${c.en}` : c.name,
    to: categoryLink(c.id),
  }));

  const groups = [
    { title: '商品', items: productItems },
    INFO_GROUP,
    SUPPORT_GROUP,
  ];

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div>
          <Logo height={32} tone="navy" />
          <p className="footer-desc">
            「道」在日語中有哲學意味，如劍道、柔道，也可延伸為「飛鏢之道」。我們專營日本入荷飛鏢工藝精品，為每位選手尋找屬於自己的標。
          </p>
        </div>

        {groups.filter(group => group.items.length > 0).map(group => (
          <div key={group.title}>
            <h4>{group.title}</h4>
            <ul>
              {group.items.map(item => (
                <li key={item.label}>
                  {item.to
                    ? <Link to={item.to}>{item.label}</Link>
                    : item.href
                      ? <a href={item.href} {...(item.href.startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>{item.label}</a>
                      : item.label}
                  {item.desc && <small style={{ display: 'block', color: 'var(--ink-soft)', fontSize: 12, marginTop: 2 }}>{item.desc}</small>}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="footer-bottom">
        <span>© 2026 MICHIDART · 道飛鏢工藝專賣 · 統一編號 87654321</span>
        <span>Crafted in Taipei · Inspired by 道</span>
      </div>
    </footer>
  );
}

export default Footer;
